import { defineMessages } from 'react-intl'

const scope = `procurify.presenter.GetExternalBankAccountsPresenter`

export default defineMessages({
  fetchingExternalBankAccountsToastError: {
    id: `${scope}.fetchingExternalBankAccountsToastError`,
    defaultMessage: 'Unable to load external bank accounts',
  },
})
